/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rd_Summary_FInputs */

const en_rd_summary_f = /** @type {(inputs: Rd_Summary_FInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not ready. Fix the basics before handing this to an agent.`)
};

const id_rd_summary_f = /** @type {(inputs: Rd_Summary_FInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum siap. Benahi dasarnya sebelum kamu serahkan ke agent.`)
};

/**
* | output |
* | --- |
* | "Not ready. Fix the basics before handing this to an agent." |
*
* @param {Rd_Summary_FInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const rd_summary_f = /** @type {((inputs?: Rd_Summary_FInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rd_Summary_FInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_rd_summary_f(inputs)
	return en_rd_summary_f(inputs)
});